import { useState, useEffect } from 'react'
import { HeaderState, DropdownState } from '../../types/header'

export const useHeaderState = () => {
  const [headerState, setHeaderState] = useState<HeaderState>({
    isUserMenuOpen: false,
    isMobileMenuOpen: false,
    isAIStudioOpen: false,
    isPriceGuideOpen: false,
    isShortVideoMenuOpen: false,
    isMyVideosOpen: false,
    isContentVideoOpen: false,
    isGenieOpen: false,
  })

  const [dropdownState, setDropdownState] = useState<DropdownState>({})

  // 모바일 메뉴가 열려있을 때 스크롤 방지
  useEffect(() => {
    if (headerState.isMobileMenuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
    }
  }, [headerState.isMobileMenuOpen])

  // 특정 상태 토글
  const toggleState = (key: keyof HeaderState) => {
    setHeaderState((prev) => ({
      ...prev,
      [key]: !prev[key],
    }))
  }

  // 특정 상태 설정
  const setState = (key: keyof HeaderState, value: boolean) => {
    setHeaderState((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  // 모든 드롭다운 닫기
  const closeAllDropdowns = () => {
    setHeaderState({
      isUserMenuOpen: false,
      isMobileMenuOpen: false,
      isAIStudioOpen: false,
      isPriceGuideOpen: false,
      isShortVideoMenuOpen: false,
      isMyVideosOpen: false,
      isContentVideoOpen: false,
      isGenieOpen: false,
    })
    setDropdownState({})
  }

  // 특정 드롭다운 토글
  const toggleDropdown = (key: string) => {
    setDropdownState((prev) => ({
      ...prev,
      [key]: !prev[key],
    }))
  }

  // 특정 드롭다운 설정
  const setDropdown = (key: string, value: boolean) => {
    setDropdownState((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  return {
    headerState,
    dropdownState,
    toggleState,
    setState,
    closeAllDropdowns,
    toggleDropdown,
    setDropdown,
  }
}
